/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
import React from 'react'
import PropTypes from 'prop-types'
import {Box, Stack} from '@salesforce/retail-react-app/app/components/shared/ui'
import useRegistrationFields from '../useRegistrationFields'
import Field from '../../field'
import PasswordRequirements from '../password-requirements'
import {nameWrapper} from '../../register/index.style'

const RegistrationFields = ({form, prefix = ''}) => {
    const fields = useRegistrationFields({form, prefix})
    const password = form.watch('password')

    return (
        <Stack spacing={5}>
            <Stack sx={nameWrapper}>
                <Field {...fields.firstName} />
                <Field {...fields.lastName} />
            </Stack>
            <Field {...fields.email} />
            <Field {...fields.mobile} type="tel" autoComplete="off" />
            <Field {...fields.birthday} />

            {/* password */}
            <Field {...fields.password} />
            <PasswordRequirements value={password} />

            <Field {...fields.confirmPassword} />

            {/* <Box sx={{margin: '20px 0'}}>
                Captcha
            </Box> */}

            {/* <Field {...fields.acceptsMarketing} inputProps={{ alignItems: 'flex-start' }} /> */}
        </Stack>
    )
}

RegistrationFields.propTypes = {
    /** Object returned from `useForm` */
    form: PropTypes.object.isRequired,

    /** Optional prefix for field names */
    prefix: PropTypes.string
}

export default RegistrationFields
